import { Injectable } from "@angular/core";
import {
  AcepSSOService,
  GlobalDomOpsService,
  GlobalDataOpsService,
  CommonOperationsService
} from "@acepteam/globalspack";
import { MemberAppDomService } from "../../services";
import {
  DomService,
  DataService,
  HelperService,
  LoggerService
} from "../../../core/services";
import { MyAccountDataOpsService } from "../../services/my-account-dataops.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Address } from "../../../shared/models";
import { FormGroup } from "@angular/forms";
import { Addresses } from "../../../shared/models/my-account-data.models";
declare var $;

@Injectable({
  providedIn: "root"
})
export class ChangeAddressService {
  constructor(
    private ssoService: AcepSSOService,
    private globalDomOpsService: GlobalDomOpsService,
    private memberAppDomService: MemberAppDomService,
    private domService: DomService,
    private globalDataOpsService: GlobalDataOpsService,
    private dataService: DataService,
    private myAccountDataService: MyAccountDataOpsService,
    private commonOpsService: CommonOperationsService,
    private helperService: HelperService,
    private loggerService: LoggerService,
    private http: HttpClient
  ) {}

  saveAddresses(addresses: Addresses): HttpResponse<any> | any {
    let payload = {
      contactid: this.ssoService.contactid,
      addresses: addresses
    };
    return this.http.post(
      this.dataService.contactapiendpoint + "UpdateAddresses",
      JSON.stringify(payload)
    );
  }

  prepareDataModel(addresses: Addresses, addressesForm: FormGroup): Addresses {
    let p: Addresses = Object.assign({}, addresses, addressesForm.value) as Addresses;

    p.home.address = Object.assign({}, p.home.address);
    p.hospital.address = Object.assign({}, p.hospital.address);
    p.business.address = Object.assign({}, p.business.address);

    return p;
  }
}
